<main id="main-content" class="h-screen flex flex-col p-8 transition-all duration-0">
    <div class="w-full h-full flex flex-col items-center justify-center gap-4">
        <img src="assets/logo.png" alt="nSide Logo" class="w-40">
        <h1 class="text-3xl oswald-font">{{ title }}</h1>
        <p *ngIf="message" class="max-w-xl text-center text-base text-nside-gray-100 raleway-font">
            {{ message }}
        </p>
    </div>
</main>
